import { render, staticRenderFns } from "./OpenNewWindowView.vue?vue&type=template&id=4bf3f8c9&"
import script from "./OpenNewWindowView.vue?vue&type=script&lang=js&"
export * from "./OpenNewWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports